var _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkinprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-68"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.99,
    y: 74.96,
    width: 125.56,
    height: 161.58,
    transform: "translate(304.52 6.98) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.22,
    y: 95.21,
    width: 157.1,
    height: 121.08,
    transform: "translate(297.54 311.5) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.63,
    y: 117.08,
    width: 1,
    height: 16.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.24 188.32 107.24 188.32 107.24 133.47 179.5 133.47 179.5 165.15 178.5 165.15 178.5 134.47 108.24 134.47 108.24 188.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.24 182.32 199.24 182.32 199.24 165.65 161.07 165.65 161.07 181.74 160.07 181.74 160.07 164.65 200.24 164.65 200.24 182.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.11,
    y: 110.88,
    width: 36.04,
    height: 12.41,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 140.65,
    width: 34.35,
    height: 13.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.77,
    y: 174.79,
    width: 23.59,
    height: 13.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.11,
    y: 177.04,
    width: 25.27,
    height: 10.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.16,
    y: 143.5,
    width: 39.03,
    height: 18.01,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.28,
    y: 181.74,
    width: 24.92,
    height: 13.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.33,
    y: 130.6,
    width: 7.61,
    height: 7.61,
    transform: "translate(137.84 -63.97) rotate(45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.2,
    y: 161.34,
    width: 7.61,
    height: 7.61,
    transform: "translate(169.21 -78.21) rotate(45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.37,
    y: 114.12,
    width: 99.59,
    height: 5.12,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.95,
    y: 95.26,
    width: 4.39,
    height: 18.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.17,
    y: 95.26,
    width: 4.39,
    height: 18.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.89,
    y: 95.02,
    width: 4.39,
    height: 18.86,
    transform: "translate(-12.67 60.8) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.39,
    y: 97.74,
    width: 4.39,
    height: 16.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.47,
    y: 97.74,
    width: 4.39,
    height: 16.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.93,
    y: 97.74,
    width: 4.39,
    height: 16.38,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.76,
    y: 97.46,
    width: 4.39,
    height: 16.38,
    transform: "translate(-15.04 74.29) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.38,
    y: 94.32,
    width: 2.19,
    height: 19.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.47,
    y: 94.32,
    width: 2.19,
    height: 19.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.03,
    y: 99.19,
    width: 21.38,
    height: 14.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.37,
    y: 152.32,
    width: 99.59,
    height: 5.12,
    transform: "translate(690.33 309.76) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.99,
    y: 133.46,
    width: 4.39,
    height: 18.86,
    transform: "translate(776.37 285.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.77,
    y: 133.46,
    width: 4.39,
    height: 18.86,
    transform: "translate(733.93 285.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.05,
    y: 133.22,
    width: 4.39,
    height: 18.86,
    transform: "translate(653.31 341.19) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.55,
    y: 135.94,
    width: 4.39,
    height: 16.38,
    transform: "translate(765.49 288.26) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.47,
    y: 135.94,
    width: 4.39,
    height: 16.38,
    transform: "translate(745.32 288.26) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.01,
    y: 135.94,
    width: 4.39,
    height: 16.38,
    transform: "translate(694.41 288.26) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.18,
    y: 135.66,
    width: 4.39,
    height: 16.38,
    transform: "translate(679 362.22) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.76,
    y: 132.52,
    width: 2.19,
    height: 19.8,
    transform: "translate(755.71 284.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.66,
    y: 132.52,
    width: 2.19,
    height: 19.8,
    transform: "translate(703.52 284.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.92,
    y: 137.39,
    width: 21.38,
    height: 14.76,
    transform: "translate(631.23 289.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.29,
    y: 182.53,
    width: 55.86,
    height: 199.14,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.11,
    y: 188.21,
    width: 46.22,
    height: 188.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 193.77,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 202.18,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 210.6,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 219.02,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 227.44,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 235.85,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 244.27,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 312.73,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 321.15,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 329.57,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 337.98,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 346.4,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 354.82,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 363.24,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.36,273.09a3.25,3.25,0,1,1-3.25-3.25A3.24,3.24,0,0,1,361.36,273.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.79,
    y: 182.53,
    width: 55.86,
    height: 199.14,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.61,
    y: 188.21,
    width: 46.22,
    height: 188.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 193.77,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 202.18,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 210.6,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 219.02,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 227.44,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 235.85,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 244.27,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 312.73,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 321.15,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 329.57,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 337.98,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 346.4,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 354.82,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.02,
    y: 363.24,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.86,273.09a3.25,3.25,0,1,1-3.25-3.25A3.24,3.24,0,0,1,303.86,273.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.79,
    y: 182.53,
    width: 55.86,
    height: 199.14,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.61,
    y: 188.21,
    width: 46.22,
    height: 188.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 193.77,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 202.18,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 210.6,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 219.02,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 227.44,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 235.85,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 244.27,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 312.73,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 321.15,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 329.57,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 337.98,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 346.4,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 354.82,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 363.24,
    width: 29.39,
    height: 1.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,273.09a3.25,3.25,0,1,1-3.25-3.25A3.24,3.24,0,0,1,418.86,273.09Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-68"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-68",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.91,402.73s-5.27-24.89,4.32-38.37-8.66-.15-10.76,12.47c0,0-3.15-22.57,6.15-38.44s-8.1-2.84-9.58,13.51c0,0-2.85-20.12,1.43-31.44s-3.17-4-6,3.06.89,24.65.89,24.65-7.46-32.47-14.52-29.89,10.55,23.86,13,34.92c0,0-8.33-14.89-14.65-11.79s9.79,4.64,17.16,26.85l2.59,10.41S76.26,364,71.25,368.61s14.85,12.64,19.47,34.91Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.88,404.16s-1.11-31.38-16.61-44.66,10.33-2.77,16.61,11.72c0,0-2.95-28-18.83-44.21s8.86-5.81,15.51,13.34c0,0-2.59-25-11.08-37.23s2.59-5.78,8.12,1.86,6.28,29.79,6.28,29.79-.74-41.11,8.49-40.12-5.54,31.72-5.17,45.7c0,0,5.54-20.32,14-18.49s-10.34,8.48-12.55,37.27v13.24s4.8-19.89,12.18-15.83-14,19.57-12.92,47.62Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.88,404.16s-1.11-31.38-16.61-44.66,10.33-2.77,16.61,11.72c0,0-2.95-28-18.83-44.21s8.86-5.81,15.51,13.34c0,0-2.59-25-11.08-37.23s2.59-5.78,8.12,1.86,6.28,29.79,6.28,29.79-.74-41.11,8.49-40.12-5.54,31.72-5.17,45.7c0,0,5.54-20.32,14-18.49s-10.34,8.48-12.55,37.27v13.24s4.8-19.89,12.18-15.83-14,19.57-12.92,47.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,402.33h45.58a0,0,0,0,1,0,0v4.92a11,11,0,0,1-11,11H82.83a11,11,0,0,1-11-11v-4.92A0,0,0,0,1,71.83,402.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.86,399.7v3.48a4.22,4.22,0,0,0,4.22,4.21h49.09a4.21,4.21,0,0,0,4.21-4.21V399.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.86,399.7v3.48a4.22,4.22,0,0,0,4.22,4.21h49.09a4.21,4.21,0,0,0,4.21-4.21V399.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.41,398.7a2.35,2.35,0,0,0-1.88-3.37,5,5,0,0,0-1.59-5.48,1.18,1.18,0,0,0-.69-.31,1.31,1.31,0,0,0-.74.33l-4.4,3.15a2.68,2.68,0,0,0-.87.87c-.9,1.74,2.34,4,1,5.4-.38.41-1,.5-1.48.8-1,.65-1.17,2.09-1.66,3.22s-2.18,2-2.83,1c.48-1.08-1-2-2.16-2.16s-2.41-.2-3.06-1.31c-1.67,1.47-5.42-2.62-5.34-4.26a3.22,3.22,0,0,0-2.61,2.68,19.34,19.34,0,0,0-.14,4.1c0,2.67-.9,5.28-.86,7.94,0,2.08.84,4.38,2.74,5.21a7,7,0,0,0,2.94.4l21.62-.14a3.25,3.25,0,0,0,1.52-.25c1-.51,1.19-1.79,1.28-2.89q.57-7.05,1.16-14.09Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,398.7a2.35,2.35,0,0,0-1.88-3.37,5,5,0,0,0-1.59-5.48,1.18,1.18,0,0,0-.69-.31,1.31,1.31,0,0,0-.74.33l-4.4,3.15a2.68,2.68,0,0,0-.87.87c-.9,1.74,2.34,4,1,5.4-.38.41-1,.5-1.48.8-1,.65-1.17,2.09-1.66,3.22s-2.18,2-2.83,1c.48-1.08-1-2-2.16-2.16s-2.41-.2-3.06-1.31c-1.67,1.47-5.42-2.62-5.34-4.26a3.22,3.22,0,0,0-2.61,2.68,19.34,19.34,0,0,0-.14,4.1c0,2.67-.9,5.28-.86,7.94,0,2.08.84,4.38,2.74,5.21a7,7,0,0,0,2.94.4l21.62-.14a3.25,3.25,0,0,0,1.52-.25c1-.51,1.19-1.79,1.28-2.89q.57-7.05,1.16-14.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.67,375.85H387.13l.27,3.39.2,2.42.51,6.3.29,3.61.39,4.82.16,2.06.06.62.2,2.43.26,3.32.17,2.07.17,2.1.2,2.42.15,1.84.17,2.07.07.89h30.79l.07-.89.16-2.06.15-1.85.2-2.43.17-2.09.17-2.07.27-3.33.19-2.42.05-.62.17-2.06.39-4.82.29-3.61.51-6.3.19-2.42.28-3.39Zm2,2.22h0l-.65-.65h.71Zm-.16,2.06-.07.82-3,3L416,380.51l3.09-3.09h.72Zm-.87,10.73-2.2,2.2L416,389.62l3.45-3.44,2.38,2.38Zm-31.92-2.3h0l2.38-2.38,3.44,3.44-3.44,3.44-2.2-2.2Zm28.61-3.5-3.45,3.45-3.44-3.45,3.44-3.44Zm-5.42-7.64h3.94l-2,2Zm.85,12.2-3.43,3.44-3.45-3.44,3.45-3.44Zm-11.43,4.55,3.44-3.43,3.44,3.43-3.44,3.45Zm2.32,4.56-3.44,3.45-3.44-3.44,3.45-3.45Zm5.68-3.44,3.43,3.45-3.43,3.44-3.45-3.45Zm-4.56-6.78-3.44-3.45,3.44-3.44,3.44,3.44Zm-1.12,1.11-3.43,3.44-3.45-3.44,3.45-3.44Zm-8-1.11-3.44-3.45,3.44-3.44,3.45,3.44Zm0,2.23,3.45,3.43-3.45,3.45-3.44-3.45Zm3.45,12.55-3.45,3.44-3.44-3.44,3.44-3.44Zm1.11,1.12,3.44,3.44-3.43,3.45-3.45-3.45Zm1.12-1.12,3.44-3.44,3.44,3.44-3.44,3.44Zm8,1.12,3.43,3.44-3.43,3.45-3.45-3.45ZM414.9,409l3.45,3.45-2.23,2.23h-2.43l-2.23-2.23Zm-3.44-5.67,3.44-3.44,3.45,3.44-3.45,3.44Zm0-9.12,3.44-3.43,3.45,3.43-3.45,3.45Zm2.32-13.66L410.35,384l-3.45-3.44,3.08-3.09h.73Zm-8-1.11-2-2h3.93Zm-1.12,1.11L401.24,384l-3.45-3.44,3.08-3.09h.73Zm-6-3.09-2,2-2-2Zm-6.16,0,3.08,3.09L392.12,384l-3-3-.06-.82,2.69-2.71Zm-3,0-.64.64h0l-.05-.64Zm-.21,6,1.68,1.68-1.43,1.44Zm.94,11.54-.14-1.63h0l.88.88-.74.75Zm.16,2.08,1.7-1.71,3.44,3.45-3.44,3.44-1.39-1.39Zm.51,6.37v-.15l.07.07-.07.08Zm.6,7.33-.43-5.28,1-1,3.44,3.44-3.44,3.44-.59-.59Zm.32,3.94-.07-.79.34-.33,1.11,1.12Zm1.38-2.23,3.44-3.45,3.45,3.45-2.23,2.23h-2.43Zm6.89,2.23,1.12-1.12,1.11,1.12Zm4.46,0-2.23-2.23,3.44-3.45,3.44,3.45L407,414.64Zm4.65,0,1.12-1.12,1.12,1.12Zm10.5,0h-1.39l1.12-1.12.33.33Zm.32-3.94-.59.59L416,407.85l3.45-3.44,1,1Zm.61-7.49,0,.16-.07-.08.09-.08Zm.19-2.42-1.39,1.39L416,398.74l3.45-3.45,1.7,1.71Zm.48-5.86-.76-.76.89-.88Zm.94-11.56-.26,3.14-1.44-1.45,1.7-1.69Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.67,375.85H387.13l.27,3.39.2,2.42.51,6.3.29,3.61.39,4.82.16,2.06.06.62.2,2.43.26,3.32.17,2.07.17,2.1.2,2.42.15,1.84.17,2.07.07.89h30.79l.07-.89.16-2.06.15-1.85.2-2.43.17-2.09.17-2.07.27-3.33.19-2.42.05-.62.17-2.06.39-4.82.29-3.61.51-6.3.19-2.42.28-3.39Zm2,2.22h0l-.65-.65h.71Zm-.16,2.06-.07.82-3,3L416,380.51l3.09-3.09h.72Zm-.87,10.73-2.2,2.2L416,389.62l3.45-3.44,2.38,2.38Zm-31.92-2.3h0l2.38-2.38,3.44,3.44-3.44,3.44-2.2-2.2Zm28.61-3.5-3.45,3.45-3.44-3.45,3.44-3.44Zm-5.42-7.64h3.94l-2,2Zm.85,12.2-3.43,3.44-3.45-3.44,3.45-3.44Zm-11.43,4.55,3.44-3.43,3.44,3.43-3.44,3.45Zm2.32,4.56-3.44,3.45-3.44-3.44,3.45-3.45Zm5.68-3.44,3.43,3.45-3.43,3.44-3.45-3.45Zm-4.56-6.78-3.44-3.45,3.44-3.44,3.44,3.44Zm-1.12,1.11-3.43,3.44-3.45-3.44,3.45-3.44Zm-8-1.11-3.44-3.45,3.44-3.44,3.45,3.44Zm0,2.23,3.45,3.43-3.45,3.45-3.44-3.45Zm3.45,12.55-3.45,3.44-3.44-3.44,3.44-3.44Zm1.11,1.12,3.44,3.44-3.43,3.45-3.45-3.45Zm1.12-1.12,3.44-3.44,3.44,3.44-3.44,3.44Zm8,1.12,3.43,3.44-3.43,3.45-3.45-3.45ZM414.9,409l3.45,3.45-2.23,2.23h-2.43l-2.23-2.23Zm-3.44-5.67,3.44-3.44,3.45,3.44-3.45,3.44Zm0-9.12,3.44-3.43,3.45,3.43-3.45,3.45Zm2.32-13.66L410.35,384l-3.45-3.44,3.08-3.09h.73Zm-8-1.11-2-2h3.93Zm-1.12,1.11L401.24,384l-3.45-3.44,3.08-3.09h.73Zm-6-3.09-2,2-2-2Zm-6.16,0,3.08,3.09L392.12,384l-3-3-.06-.82,2.69-2.71Zm-3,0-.64.64h0l-.05-.64Zm-.21,6,1.68,1.68-1.43,1.44Zm.94,11.54-.14-1.63h0l.88.88-.74.75Zm.16,2.08,1.7-1.71,3.44,3.45-3.44,3.44-1.39-1.39Zm.51,6.37v-.15l.07.07-.07.08Zm.6,7.33-.43-5.28,1-1,3.44,3.44-3.44,3.44-.59-.59Zm.32,3.94-.07-.79.34-.33,1.11,1.12Zm1.38-2.23,3.44-3.45,3.45,3.45-2.23,2.23h-2.43Zm6.89,2.23,1.12-1.12,1.11,1.12Zm4.46,0-2.23-2.23,3.44-3.45,3.44,3.45L407,414.64Zm4.65,0,1.12-1.12,1.12,1.12Zm10.5,0h-1.39l1.12-1.12.33.33Zm.32-3.94-.59.59L416,407.85l3.45-3.44,1,1Zm.61-7.49,0,.16-.07-.08.09-.08Zm.19-2.42-1.39,1.39L416,398.74l3.45-3.45,1.7,1.71Zm.48-5.86-.76-.76.89-.88Zm.94-11.56-.26,3.14-1.44-1.45,1.7-1.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 384.98,
    y: 374.44,
    width: 41.62,
    height: 4.39,
    rx: 1.64,
    transform: "translate(811.58 753.27) rotate(180)",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.98,
    y: 413.85,
    width: 35.62,
    height: 4.39,
    rx: 1.64,
    style: {
      fill: "#20CEC0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.93,396.24l-27.88-2.74V362.06H328v31.43l-28,2.75a5.43,5.43,0,0,0-4.9,5.4v4.19h76.71v-4.19A5.43,5.43,0,0,0,366.93,396.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.93,396.24l-27.88-2.74V362.06H328v31.43l-28,2.75a5.43,5.43,0,0,0-4.9,5.4v4.19h76.71v-4.19A5.43,5.43,0,0,0,366.93,396.24Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.06,
    cy: 411.02,
    r: 7.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.87,
    cy: 411.02,
    r: 7.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,335.58H341a0,0,0,0,1,0,0v30.76a4.13,4.13,0,0,1-4.13,4.13h-6.59a4.13,4.13,0,0,1-4.13-4.13V335.58A0,0,0,0,1,326.1,335.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,335.58H341a0,0,0,0,1,0,0v30.76a4.13,4.13,0,0,1-4.13,4.13h-6.59a4.13,4.13,0,0,1-4.13-4.13V335.58A0,0,0,0,1,326.1,335.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.11,275s-8.28,51.68-24.61,60.57h16.6S380.51,318,385.51,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.11,275s-8.28,51.68-24.61,60.57h16.6S380.51,318,385.51,275Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.33,328.28h74.43a0,0,0,0,1,0,0v6.31a5,5,0,0,1-5,5H300.33a5,5,0,0,1-5-5v-6.31A0,0,0,0,1,295.33,328.28Z",
    transform: "translate(665.09 667.87) rotate(-180)",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.23,
    y: 333.93,
    width: 80.63,
    height: 5.66,
    rx: 2.01,
    transform: "translate(665.09 673.52) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.23,
    y: 333.93,
    width: 80.63,
    height: 5.66,
    rx: 2.01,
    transform: "translate(665.09 673.52) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47,285.51H360.86c-7.79,0-12.85-6.25-11.3-14l2.07-10.29c1.54-7.71,9.12-14,16.91-14h26.6c7.8,0,12.86,6.25,11.31,14l-2.07,10.29C402.83,279.26,395.26,285.51,387.47,285.51Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.72,250.89,245.83,247a8.61,8.61,0,0,0-3.7-1.74,60.16,60.16,0,0,0-11.35.89c-1,.39-.64,8.42,0,8.55s10.59.25,11.48,0,3.06-2.68,3.06-2.68l5.11,3.42Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,240.13c-3.62,3.24-15,16.81-16.78,17.3s-18.42-10-18.42-10l-2.36,6.61s15.66,12.89,20.78,13.78c5.55,1,24.05-14,24.05-14Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,253.82S287,257.2,282,260.64c-5.5,3.8-12,7.69-14.89,7.18-5.13-.88-20.79-13.77-20.79-13.77l2.36-6.61s16.66,10.47,18.43,10,13.16-14.06,16.76-17.3l4.76,8.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.17,253.82S287,257.2,282,260.64c.85-4.71,4.69-9.44,6.63-11.57Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,282.54s-16.81-29.38-17.63-42.41c0,0,5.77-10.67,13.34-13s27.61-1,27.61-1,15.85,16.26,24.43,53.25Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,282.54s-16.81-29.38-17.63-42.41c0,0,5.77-10.67,13.34-13s27.61-1,27.61-1,15.85,16.26,24.43,53.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.39 248.51 323.35 246.17 326.98 255.38 323.15 259.47 316.91 257.43 313.39 248.51",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.43 408.3 301.89 409.89 294.31 390.86 302.84 389.28 310.43 408.3",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.84 389.28 294.32 390.87 298.65 401.75 307.03 399.76 302.84 389.28",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.61 411.56 212.5 406.58 220.78 387.85 227.88 392.83 219.61 411.56",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.88 392.83 220.78 387.86 216.05 398.57 223.33 403.16 227.88 392.83",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,311.45l-27.25,8.35L256.8,336.48C244.27,365.58,228.92,396,228.92,396l-14.22-5.84s15.31-51.09,19.78-63.86c7.14-20.38,83.42-34,83.42-34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.21 401.34 210.7 393.76 212.98 385.76 232.02 394.45 228.21 401.34",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.21 401.34 210.7 393.76 212.98 385.76 232.02 394.45 228.21 401.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.41,406.07s-.1-.1-.1-.11l-.11-.11h0l.12.1c.06-.12,1.27-2.26.82-3.37a1,1,0,0,0-.65-.58.76.76,0,0,0-.9.28,3.19,3.19,0,0,0-.12,2.17c-.58-.73-1.31-1.46-1.92-1.49a.81.81,0,0,0-.66.34,1.09,1.09,0,0,0-.22,1.14,2.29,2.29,0,0,0,1.32,1,10.56,10.56,0,0,0,2.21.64l.07,0,.06,0Zm-.49-3.52c.07-.1.19-.2.47-.11l.09,0a.59.59,0,0,1,.32.34c.28.66-.21,1.95-.56,2.7a1.63,1.63,0,0,0-.11-.17A4.16,4.16,0,0,1,210.92,402.55ZM208,404.29a.73.73,0,0,1,.16-.72.37.37,0,0,1,.32-.17c.61,0,1.64,1.27,2.3,2.26C209.28,405.32,208.26,404.82,208,404.29Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,405.36l8.92,3.9a.61.61,0,0,1,.35.8h0L219,417.32a1.54,1.54,0,0,1-2,.8c-3.09-1.41-4.49-2.24-8.4-4-2.41-1.06-7.27-2.92-10.33-4.89s-1-4.94.44-4.38c3.49,1.32,9.1,1.14,12.11.36A2.42,2.42,0,0,1,212.4,405.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.83,409h0c0-.15-.15-2.61-1.05-3.39a1.26,1.26,0,0,0-1-.22.81.81,0,0,0-.74.65,3.11,3.11,0,0,0,.85,2,3.56,3.56,0,0,0-2.4-.45.79.79,0,0,0-.44.61,1.1,1.1,0,0,0,.32,1.11,2.33,2.33,0,0,0,1.65.32,10.29,10.29,0,0,0,2.26-.45.09.09,0,0,0,.07,0s0,0,0-.06.21-.05.22-.08l.18,0Zm-2.39-2.88c0-.12.08-.26.36-.31l.1,0a.59.59,0,0,1,.44.16c.55.46.7,1.83.74,2.65l-.18-.1A4.05,4.05,0,0,1,298.44,406.12ZM296.67,409a.75.75,0,0,1-.19-.71.35.35,0,0,1,.21-.3c.55-.26,2,.38,3.08.95C298.24,409.34,297.1,409.36,296.67,409Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,408l9.72-.61a.61.61,0,0,1,.67.55h0l1,7.66a1.54,1.54,0,0,1-1.42,1.63c-3.39.15-5,.06-9.3.29-2.62.16-7.8.72-11.42.37s-3.18-3.93-1.61-4.1c3.71-.42,8.62-3.14,10.94-5.21A2.4,2.4,0,0,1,301,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9,231.82a6.91,6.91,0,0,1,4.6,0,6.69,6.69,0,0,0,6.43,5.16,12.12,12.12,0,0,0,2.21-.09c7.49-1,6.67-12.17,6.67-12.17a13.29,13.29,0,0,1-7.8-1.87h0a17.34,17.34,0,0,1-5.11-4.57Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9,231.82a6.91,6.91,0,0,1,4.6,0,6.69,6.69,0,0,0,6.43,5.16c1.93-4.77,1.68-10.23,1.08-14.13h0a17.34,17.34,0,0,1-5.11-4.57Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.68,207.2c3.7,1.6,2.92,5.65-3.38,13-3.75-3.33-5.69-10.82-3.66-13.18S276.45,205.81,279.68,207.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,210.63c1.16,8.08,2.24,12.75-.93,17.68-4.78,7.41-15.38,5.8-18.94-1.78-3.18-6.8-4.55-18.87,2.6-23.65a11.14,11.14,0,0,1,17.27,7.75Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.47,215.29c.14.65-.1,1.24-.53,1.33s-.87-.36-1-1,.09-1.25.52-1.34S283.29,214.66,283.47,215.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.09,216.83c.14.64-.1,1.24-.52,1.33s-.88-.36-1-1,.1-1.25.53-1.33S276,216.18,276.09,216.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.56,216.63a23.67,23.67,0,0,1-1.95,6.2,3.83,3.83,0,0,0,3.23-.07Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,204.22c-3.47,2.05-2.18,6,5,12.42,3.3-3.79,4.28-11.47,2-13.54S293.32,202.44,290.29,204.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.05,216.23a7.75,7.75,0,0,1-2.67,5.29c-2.08,1.75-4.24.17-4.61-2.38-.33-2.3.35-6,2.89-6.74S300.23,213.72,300.05,216.23Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,211.47a.43.43,0,0,1-.42.09,3.35,3.35,0,0,0-3,.31.41.41,0,0,1-.51-.65h0a4.13,4.13,0,0,1,3.75-.44.4.4,0,0,1,.26.51h0A.62.62,0,0,1,286.78,211.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,213.46a.39.39,0,0,1-.22-.11.42.42,0,0,1,.11-.57h0a4.1,4.1,0,0,1,3.75-.44.4.4,0,0,1,.21.54h0a.41.41,0,0,1-.54.21h0a3.36,3.36,0,0,0-3,.4A.39.39,0,0,1,272.08,213.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,204s1.78-3.54-2.9-6.61-18.84-.67-23.91,5.75-.67,10.33-.67,10.33a4.63,4.63,0,0,1,.47-3.12,5.69,5.69,0,0,0,2.45,2.52c1.61.72.54.49.54.49a7,7,0,0,1,1.54-4.67,10.89,10.89,0,0,0,4.32,2.6,6.15,6.15,0,0,1,2.35-3.47s.88,2.83,2.23,3.1c0,0-.12-2.31,3-4,0,0,.35,2.2,1.23,2.78C287.06,209.78,288.55,204.8,296.38,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.92,225.48a.36.36,0,0,1-.2-.06.37.37,0,0,1-.12-.52,8.86,8.86,0,0,1,4.8-3.42.36.36,0,0,1,.46.25.38.38,0,0,1-.25.47,8.23,8.23,0,0,0-4.38,3.1A.36.36,0,0,1,281.92,225.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,220a4,4,0,0,1-3.6-3.42c-.42-2.21.76-4.3,2.63-4.66s3.73,1.16,4.15,3.37a4.47,4.47,0,0,1-.44,3,3.21,3.21,0,0,1-2.19,1.65A3.31,3.31,0,0,1,282.27,220Zm-.42-7.6a2.28,2.28,0,0,0-.45,0c-1.58.3-2.58,2.11-2.21,4h0c.36,1.92,1.94,3.26,3.53,2.95a2.67,2.67,0,0,0,1.83-1.39,3.92,3.92,0,0,0,.38-2.65A3.42,3.42,0,0,0,281.85,212.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.67,221.45a3.26,3.26,0,0,1-2.08-.79,4.48,4.48,0,0,1-1.51-2.64h0c-.42-2.21.76-4.29,2.63-4.65a3.2,3.2,0,0,1,2.64.74,4.46,4.46,0,0,1,1.51,2.63,4.54,4.54,0,0,1-.44,3,3.19,3.19,0,0,1-2.19,1.64A2.67,2.67,0,0,1,273.67,221.45Zm-3.07-3.52a3.93,3.93,0,0,0,1.32,2.32,2.57,2.57,0,0,0,4-.76,4.13,4.13,0,0,0-.95-5,2.65,2.65,0,0,0-2.2-.62c-1.59.3-2.58,2.11-2.21,4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6,217.05a.28.28,0,0,1-.16-.05.26.26,0,0,1-.05-.37,2.05,2.05,0,0,1,2.68-.37.27.27,0,0,1,.09.36.26.26,0,0,1-.37.09,1.55,1.55,0,0,0-2,.24A.26.26,0,0,1,276.6,217.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,215.57a.26.26,0,0,1-.25-.2.26.26,0,0,1,.18-.32l7.5-2.1a.28.28,0,0,1,.33.19.27.27,0,0,1-.19.32l-7.5,2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.16,319.8,256.8,336.48s-2-15,7.79-22c14.3-10.26,45.84-13.13,45.84-13.13S310.82,310.27,311.16,319.8Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,302.55l2.1-13.15-.84-6.86,47.75-3.19L350,287s5.68,26.84,1.74,34.12c-7,13-36,12.49-61.19,12.49,5.47,16,16.45,56.5,16.45,56.5l-13.17,6s-25.41-46.22-31.18-66.23C257.58,312.21,282.29,306.91,300.27,302.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.99 393.73 292.32 400.92 288.2 393.7 307.74 386.18 309.99 393.73",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.99 393.73 292.32 400.92 288.2 393.7 307.74 386.18 309.99 393.73",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "334.31 287.49 350.58 286.52 349.6 280.48 333.69 281.5 334.31 287.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.23 283.38 301.53 283.56 302.37 289.4 304.7 289.26 304.23 283.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.61 289.15 332.4 287.61 331.92 281.61 306 283.27 306.61 289.15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.19,289.23a2.23,2.23,0,0,1-2.23-2.05l-.19-2.18a2.23,2.23,0,0,1,2-2.42l4.63-.4a2.19,2.19,0,0,1,1.64.52,2.22,2.22,0,0,1,.78,1.52l.19,2.18a2.22,2.22,0,0,1-.52,1.64,2.19,2.19,0,0,1-1.52.79l0-.5,0,.5-4.63.39Zm4.44-6.06h-.1l-4.63.4a1.23,1.23,0,0,0-1.13,1.34l.18,2.19a1.24,1.24,0,0,0,.44.84,1.28,1.28,0,0,0,.9.29l4.63-.4a1.25,1.25,0,0,0,.85-.44,1.27,1.27,0,0,0,.29-.9l-.19-2.18a1.25,1.25,0,0,0-.44-.85A1.21,1.21,0,0,0,318.63,283.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.48,286.2a.51.51,0,0,1-.5-.43.5.5,0,0,1,.43-.56l1.91-.26a.49.49,0,0,1,.57.42.51.51,0,0,1-.43.57l-1.92.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,241.23s4.84,17.11,10.69,28.69c0,0-9.21-17.17-12.65-30.4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.72,244.42l2.49-3.25h1.34l1.91,2,.19,2.28c-2.35,1.05-5.93,0-5.93,0Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11,242a65.33,65.33,0,0,0-1.34-12.36l1.34.58a32.77,32.77,0,0,1,1.34,12.63Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,244.52s-9.41-3.72-10.31-9.82l-.66,1.15s2.24,7.71,12.14,9.62Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.34,243.94a6,6,0,0,0,4.47-3.35c2.23-5.13,0-12.66,5.52-16l3.1,1.1a10.19,10.19,0,0,0-3.6,5.23c-1.12,4.3-2.39,14.94-9.49,14.54Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.12,222.86l-4.61,11.32-.37,2.71-3.27-1.56-5.27-3.14s-2.34,3.27,1.57,8.37l3.7-3.06,5.19,5.69,1.47-7,6.05,1.95S310,228,310,225.1Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,225.1c0,2.92-2.43,13.07-2.43,13.07l-6.06-1.95-1.46,7-5.19-5.69-3.7,3.06c-3.91-5.1-1.58-8.37-1.58-8.37l5.28,3.14,3.27,1.56.37-2.71,4.6-11.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.58 238.17 301.52 236.22 300.06 243.19 299.74 234.43 307.58 238.17",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.06 243.19 294.87 237.5 291.17 240.56 293.81 235.84 300.06 243.19",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,254.12l-7.75-.87a8.56,8.56,0,0,0-3.7-1.74,60.26,60.26,0,0,0-11.36.88c-1,.39-.64,8.42,0,8.56s10.59.25,11.49,0,3.06-2.68,3.06-2.68l6.79,1.2Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,226.1c-3.2.65-18,28.76-18,28.76L268.76,253l-.57,6.52s34.13,7.43,41.82,6,21.56-25.43,22.39-28.07C334.29,231.44,327,225.66,324.85,226.1Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,226.1c-3.2.65-18,28.76-18,28.76L268.76,253l-.57,6.52s34.13,7.43,41.82,6,21.56-25.43,22.39-28.07C334.29,231.44,327,225.66,324.85,226.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.08 262.89 115.08 259.62 112.89 259.62 115.08 258.34 113.44 258.34 115.63 256.91 117.71 256.91 117.71 255.26 115.3 255.26 117.71 254.3 117.71 250.73 115.3 250.73 115.3 248.4 112.89 248.4 115.3 247.59 115.3 245.93 113.57 245.93 114.98 244.52 116.21 243.29 153.59 243.29 153.59 244.97 156.06 244.97 153.31 246.2 153.31 247.59 158.35 247.59 158.35 250.16 160.58 250.16 158.35 251.28 158.35 254.16 156.77 254.16 156.77 255.53 153.59 255.53 153.59 259.62 155.37 259.62 153.91 261.08 153.91 262.9 115.08 262.89",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.08 262.89 115.08 259.62 112.89 259.62 115.08 258.34 113.44 258.34 115.63 256.91 117.71 256.91 117.71 255.26 115.3 255.26 117.71 254.3 117.71 250.73 115.3 250.73 115.3 248.4 112.89 248.4 115.3 247.59 115.3 245.93 113.57 245.93 114.98 244.52 116.21 243.29 153.59 243.29 153.59 244.97 156.06 244.97 153.31 246.2 153.31 247.59 158.35 247.59 158.35 250.16 160.58 250.16 158.35 251.28 158.35 254.16 156.77 254.16 156.77 255.53 153.59 255.53 153.59 259.62 155.37 259.62 153.91 261.08 153.91 262.9 115.08 262.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.08 262.89 115.08 259.62 112.89 259.62 115.08 258.34 113.44 258.34 115.63 256.91 117.71 256.91 117.71 255.26 115.3 255.26 117.71 254.3 117.71 250.73 115.3 250.73 115.3 248.4 112.89 248.4 115.3 247.59 115.3 245.93 113.57 245.93 114.98 244.52 116.21 243.29 135.9 243.29 135.9 244.97 138.37 244.97 135.62 246.2 135.62 247.59 140.66 247.59 140.66 250.16 142.89 250.16 140.66 251.28 140.66 254.16 139.08 254.16 139.08 255.53 135.9 255.53 135.9 259.62 137.68 259.62 136.22 261.08 136.22 262.9 115.08 262.89",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.31 247.59 135.62 247.59 153.31 246.95 153.31 247.59",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.59 255.53 135.9 255.53 135.82 256.77 153.59 255.53",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.77 254.16 139.08 254.16 156.77 254.78 156.77 254.16",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.59 259.62 135.9 259.62 153.59 258.96 153.59 259.62",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.91 261.08 136.22 261.08 136.22 261.75 153.91 261.08",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.35 250.16 140.66 250.16 158.35 249.6 158.35 250.16",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.59 244.97 135.9 244.97 153.59 244.35 153.59 244.97",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.3 245.93 133.24 245.93 115.3 246.48 115.3 245.93",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.62 247.59 115.3 247.59 133.72 248.19 135.62 247.59",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.66 250.16 115.3 250.73 115.3 250.16 140.66 250.16",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.66 251.28 128.12 251.28 140.66 251.9 140.66 251.28",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.71 254.3 135.9 254.16 117.71 253.75 117.71 254.3",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.71 255.26 136.22 255.26 117.71 255.88 117.71 255.26",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.08 258.34 135.62 258.34 135.62 258.96 115.08 258.34",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.08 259.62 129.97 259.62 115.08 260.03 115.08 259.62",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.72 263.52 220.54 260.42 254.29 260.42 269.83 261.97 270.42 263.52 219.72 263.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.29 260.42 254.29 263.52 219.72 263.52 220.54 260.42 254.29 260.42",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,226l7.39,33.5a2.51,2.51,0,0,0,2.4,1.91h23.89a1.63,1.63,0,0,0,1.52-2.11l-7.38-33.24a2.3,2.3,0,0,0-2.4-1.64H148.59C147.5,224.45,146.82,224.94,147.06,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,226l7.38,33.5a2.51,2.51,0,0,0,2.4,1.91h22.53a1.64,1.64,0,0,0,1.52-2.11l-7.38-33.24a2.3,2.3,0,0,0-2.4-1.64H150C148.87,224.45,148.19,224.94,148.43,226Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.41,259.23v3.11c0,.79.94,1.12,1.72,1.12h55.28c.79,0,1.75-.33,1.75-1.12v-3.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16,259.23v3.11c0,.79-.94,1.12-1.72,1.12H160.17c-.8,0-1.76-.33-1.76-1.12v-3.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16,259.23v3.11c0,.79-.94,1.12-1.72,1.12H190c-.8,0-1.75-.33-1.75-1.12v-3.11Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.92 256.77 174.21 226.6 149.77 226.6 156.42 256.77 180.92 256.77",
    style: {
      fill: "#20CEC0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.51,245.56a2.66,2.66,0,0,1-2.68,3h-51.7a3.32,3.32,0,0,1-3.24-3l-3.07-33.1a2.82,2.82,0,0,1,.06-1,2.65,2.65,0,0,1,2.62-2h51.7a3.32,3.32,0,0,1,3.24,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.64,248.53H193.13a3.32,3.32,0,0,1-3.24-3l-3.07-33.1a2.82,2.82,0,0,1,.06-1H238.4a3.34,3.34,0,0,1,3.24,3l3.07,33.1A2.8,2.8,0,0,1,244.64,248.53Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.12 228.23 219.82 228.23 216.97 258.85 233.88 261.39 233.88 263.52 198.26 263.52 198.26 261.39 205.56 258.85 209.12 228.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.82 228.23 211.9 263.04 205.56 262.85 209.12 228.23 219.82 228.23",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.14 418.24 178.22 418.24 167.56 269.97 175.43 269.97 184.14 418.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.15 418.24 178.22 418.24 168.09 277.33 167.56 270.2 175.43 270.2 175.85 277.33 184.15 418.24",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.85 276.98 168.09 276.98 167.56 270.2 175.43 270.2 175.85 276.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.67 418.24 250.74 418.24 249.78 269.97 257.64 269.97 256.67 418.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.64 270.2 257.49 294.13 256.68 418.24 250.74 418.24 249.93 294.13 249.78 270.2 257.64 270.2",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.64 270.2 257.49 294.39 249.93 294.39 249.78 270.2 257.64 270.2",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.6 418.24 313.68 418.24 303.02 269.97 310.89 269.97 319.6 418.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.61 418.24 313.68 418.24 303.54 277.33 303.02 270.2 310.89 270.2 311.31 277.33 319.61 418.24",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.31 276.98 303.54 276.98 303.02 270.2 310.89 270.2 311.31 276.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.33 418.24 110.41 418.24 119.12 269.97 126.98 269.97 116.33 418.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.98 270.2 126.46 277.33 116.33 418.24 110.41 418.24 118.69 277.33 119.12 270.2 126.98 270.2",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.12 270.2 126.98 270.2 126.46 276.98 118.69 276.98 119.12 270.2",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89,266.25H317.12a0,0,0,0,1,0,0v5.26a2.16,2.16,0,0,1-2.16,2.16H115a2.16,2.16,0,0,1-2.16-2.16v-5.26A0,0,0,0,1,112.89,266.25Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89,266.25H317.12a0,0,0,0,1,0,0v5.26a2.16,2.16,0,0,1-2.16,2.16H115a2.16,2.16,0,0,1-2.16-2.16v-5.26A0,0,0,0,1,112.89,266.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.89,
    y: 266.25,
    width: 204.24,
    height: 3.71,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8,267.22H109.21a2.1,2.1,0,0,1-2.09-2.09h0a2.09,2.09,0,0,1,2.09-2.09H320.8a2.09,2.09,0,0,1,2.09,2.09h0A2.1,2.1,0,0,1,320.8,267.22Z",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8,267.22H109.21a2.1,2.1,0,0,1-2.09-2.09h0a2.09,2.09,0,0,1,2.09-2.09H320.8a2.09,2.09,0,0,1,2.09,2.09h0A2.1,2.1,0,0,1,320.8,267.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.62 253.6 269.62 254.3 267.21 255.26 269.62 255.26 269.62 256.91 267.54 256.91 265.34 258.34 266.99 258.34 264.8 259.62 266.99 259.62 266.99 262.89 305.82 262.9 305.82 261.08 307.28 259.62 305.49 259.62 305.49 255.53 308.68 255.53 308.68 254.16 310.26 254.16 310.26 253.6 269.62 253.6",
    style: {
      fill: "#20CEC0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.62 253.6 269.62 254.3 267.21 255.26 269.62 255.26 269.62 256.91 267.54 256.91 265.34 258.34 266.99 258.34 264.8 259.62 266.99 259.62 266.99 262.89 305.82 262.9 305.82 261.08 307.28 259.62 305.49 259.62 305.49 255.53 308.68 255.53 308.68 254.16 310.26 254.16 310.26 253.6 269.62 253.6",
    style: {
      fill: "#fff",
      opacity: 0.9,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.62 253.6 269.62 254.3 267.21 255.26 269.62 255.26 269.62 256.91 267.54 256.91 265.34 258.34 266.99 258.34 264.8 259.62 266.99 259.62 266.99 262.89 288.13 262.9 288.13 261.08 289.59 259.62 287.8 259.62 287.8 255.53 290.99 255.53 290.99 254.16 292.57 254.16 292.57 253.6 269.62 253.6",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.49 255.53 287.8 255.53 287.73 256.77 305.49 255.53",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.68 254.16 290.99 254.16 308.68 254.78 308.68 254.16",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.49 259.62 287.8 259.62 305.49 258.96 305.49 259.62",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.82 261.08 288.13 261.08 288.13 261.75 305.82 261.08",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.62 254.3 287.8 254.16 269.62 253.75 269.62 254.3",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.62 255.26 288.13 255.26 269.62 255.88 269.62 255.26",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.99 258.34 287.53 258.34 287.53 258.96 266.99 258.34",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.99 259.62 281.87 259.62 266.99 260.03 266.99 259.62",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkinprogress);
export default __webpack_public_path__ + "static/media/Workinprogress.74b234fe72d7631e7f3af49f79e92eee.svg";
export { ForwardRef as ReactComponent };